import { Table } from "react-bootstrap";
import { DateFormat } from "../Helper";

const Bookings = ({ bookings }) => {
  return (
    <>
      {bookings && bookings.length > 0 && (
        <Table bordered responsive className="border border-primary-subtle">
          <thead>
            <tr>
              <th>#</th>
              <th>Booking No</th>
              <th>Service</th>
              <th>From</th>
              <th>To</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {bookings.map((booking, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{booking.booking_no}</td>
                <td>{booking.title}</td>
                <td>
                  <DateFormat value={booking.start} dateTime />
                </td>
                <td>
                  <DateFormat value={booking.end} dateTime />
                </td>
                <td>{booking.status}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default Bookings;
